import React, { useState } from "react";
import styled from "styled-components";
import Components from "../../components";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { Helmet } from "react-helmet-async";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const { AuthForm, Width } = Components;

const COMPANY_NAME = "ООО «Цифра брокер»";
const CERTIFICATE_CN = "*.partners.cifra-broker.by";

const FirstBlock = styled.div`
  width: 100%;
  padding: 80px 0px;
  border-bottom: 1px solid #d1d3d4;

  & > div {
    display: flex;
  }
`;

const BTitile = styled.div`
  white-space: pre-line;
  font-weight: 500;
  font-size: 32px;
  line-height: 110%;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(250px, 1fr));
  gap: 40px;
  margin-inline-start: 30px;
`;

const ContentIn = styled.div`
  display: flex;
  align-items: self-start;
`;

const WelcomeByPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch("/documents/by/Cifra_Markets.pdf");
      if (!response.ok) throw new Error(t("welcome.downloadFailed"));

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);

      window.open(url, "_blank");
    } catch (e) {
      alert(e.message || t("welcome.downloadFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("welcome.metaTitle")} - BY</title>
        <meta
          name="description"
          content={`${t("welcome.metaDescription")} BY`}
        />
        <link rel="icon" href="/images/by/favicon.ico" />
      </Helmet>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.loginTitle")}</BTitile>
          <Content>
            <ContentIn>
              <AuthForm />
            </ContentIn>
            <ContentIn>
              {t("welcome.newCabinetNoticePartner", { company: COMPANY_NAME })}
            </ContentIn>
          </Content>
        </Width>
      </FirstBlock>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.partnersTitle")}</BTitile>
          <Content>
            <ContentIn>
              <div>
                {t("welcome.securityCertificate")} <b>CN = {CERTIFICATE_CN}</b>
              </div>
            </ContentIn>
            <ContentIn>{t("welcome.passwordWarning")}</ContentIn>
            <ContentIn>{t("welcome.emailAccessWarning")}</ContentIn>
            <ContentIn>{t("welcome.fraudWarning")}</ContentIn>
          </Content>
        </Width>
      </FirstBlock>

      <FirstBlock>
        <Width>
          <BTitile>{t("welcome.howToBecomePartner")}</BTitile>
          <Content>
            <ContentIn>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                onClick={handleDownload}
                startIcon={<CloudDownloadIcon />}
                size="large"
                sx={{
                  color: "white",
                  textTransform: "none",
                  fontWeight: "normal",
                }}
                title={t("welcome.download")}
              >
                {t("welcome.getConditions")}
              </Button>
            </ContentIn>
          </Content>
        </Width>
      </FirstBlock>
    </>
  );
};

export default WelcomeByPage;
